import { type PayoutPaymentChannel, type PayoutTraderConfigUpdate } from '~/entities/payout';
import { type ConfigForm, type UpdateTraderConfigRequest } from '../../model';

// UpdateTraderConfigV2 полностью заменяет конфиг, поэтому объект собирается
// строго по write-модели v2: без legacy `limit` и enum-полей банков в фильтрах.
const toPaymentChannelUpdate = (channel: PayoutPaymentChannel) => ({
    config: channel.config,
    filter: channel.filter && {
        amount: channel.filter.amount,
        bankCodes: channel.filter.bankCodes,
        currency: channel.filter.currency,
        method: channel.filter.method,
        type: channel.filter.type,
    },
});

export const buildUpdateTraderConfigRequest = (values: ConfigForm): UpdateTraderConfigRequest => {
    const { acceptRateLimitMode, config, traderId } = values;

    const configUpdate: PayoutTraderConfigUpdate = {
        allowedMarkets: config?.allowedMarkets,
        canSplitOrder: config?.canSplitOrder,
        limits: config?.limits,
        minSplitChildAmount: config?.minSplitChildAmount,
        paymentChannels: config?.paymentChannels?.map(toPaymentChannelUpdate),
    };

    // Отсутствие acceptRateLimit в запросе — сброс override на глобальный дефолт.
    if (acceptRateLimitMode === 'unlimited') {
        configUpdate.acceptRateLimit = { maxAccepts: '0' };
    }

    if (acceptRateLimitMode === 'custom') {
        configUpdate.acceptRateLimit = {
            maxAccepts: config?.acceptRateLimit?.maxAccepts,
            windowSeconds: config?.acceptRateLimit?.windowSeconds,
        };
    }

    return {
        config: configUpdate,
        traderId,
    };
};
